export const VITALITY_ROUTE = '/vitality';
